import React, { Component } from 'react';
import {Demands} from 'api';
import Promise from 'bluebird';
import {
  ConversationItem,
  SendMessageForm,
  ConversationContainer
} from 'components/conversations';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Textarea} from 'components/vitrade-forms/common';

class DemandConversationsContainer extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      hasOwnConversation: null,
      conversations: []
    }
  }

  loadConversations() {
    Promise.all([
      Demands.actions.listConversations.request({
        id: this.props.demand.id,
        filter: {
          limit: 100,
          include: [
            {
              relation: 'owner',
              scope: {
                fields: ['username', 'email']
              },

            }
          ]
        }
      }),
      Demands.actions.hasOwnConversation.request({
        id: this.props.demand.id
      })
    ]).spread((conversations, hasOwnConversation) => {
      this.setState({
        conversations: conversations.data,
        hasOwnConversation: hasOwnConversation.data
      })
    })
  }

  componentDidMount() {
    this.loadConversations();
  }

  onConversationCreate() {
    this.loadConversations();
  }

  loadConversation(conversation) {
    this.setState({
      activeConversation: conversation
    })
  }

  backToConversationList() {
    this.setState({
      activeConversation: null
    })
  }

  confirmDelete(id, reload) {
    if (confirm("Bạn có muốn xóa trao đổi này không?")) {
      // Demands.actions.delete.request({id}).then(response => {
      //   toastr.removeByType('success');
      //   toastr.success("", "Trao đổi đã được xóa");
      //   reload();
      // });
    }
  }

  render() {
    return (
      <div className='need-offer-container mb35'>
        {!this.state.activeConversation &&
          <div className='need-offer-list-comment-container'>
            <div className='need-offer-business-detail-wrap'>
              <p className='need-offer-back-to-list'>Các phản hồi từ doanh nghiệp</p>

              <div className='need-offer-list-business'>
                {
                  this.state.conversations.map((conversation, i) => {
                    return (
                      <ConversationItem {...conversation} className='' index={(i + 1)}
                        actionPanel={
                          <div>
                            <div className='row'>
                              <button className="btn btn-primary" type="button" onClick={this.loadConversation.bind(this, conversation)}>Chi tiết</button>&nbsp;
                              <button className="btn btn-danger" type="button" onClick={this.confirmDelete.bind(this, conversation.id)}>Xóa</button>
                            </div>
                          </div>
                        }
                        onClick={this.loadConversation.bind(this, conversation)}
                      />

                    );
                  })
                }
              </div>

            </div>
          </div>
        }
        {
          this.state.activeConversation &&
          <div className='need-offer-list-comment-container'>
            <div className='need-offer-business-detail-wrap'>
              <a href='javascript:void(0)' className='need-offer-back-to-list' onClick={this.backToConversationList.bind(this)}><i className='fa fa-arrow-circle-o-left'/>Trở lại danh sách</a>
              <ConversationItem {...this.state.activeConversation} className=''
                onClick={() => {}}
              />
            </div>

            <ConversationContainer
              conversation={this.state.activeConversation}
            />
            <SendMessageForm
              conversation={this.state.activeConversation}
            />

            {/* <form className='need-offer-post-comment-form'>
              <Textarea type="text" className='need-offer-post-comment-input mb15' placeholder="Nhập phản hồi..."/>
              <button type='submit' className='need-offer-post-comment-btn'>Phản hồi</button>
            </form> */}
          </div>

        }
      </div>
    );
  }
}

export default connect()(DemandConversationsContainer);



// WEBPACK FOOTER //
// ./components/demand/DemandConversationsContainer.jsx